import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from 'react-router-dom';

const NavMenuHeader: React.FC = () => {
    useEffect(() => {
        require('bootstrap/dist/js/bootstrap.bundle.min.js');
    }, []);
    const handleLogin = () => {
        window.location.href = '/api/v1/auth/login/google'; // Redirect to Google SSO endpoint
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-custom">
            <div className="container-fluid">
            <Link className="navbar-brand" id="nav_font" to="/" >FinTrack</Link>
            
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarContent">
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle nav-link-custom" id="nav_font" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Calculators
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-custom">
                    <li><Link className="dropdown-item" to="/calculator?type=mutual-fund">Mutual Fund Calculator</Link></li>
                    <li><Link className="dropdown-item" to="/calculator?type=home-emi">Home EMI Calculator</Link></li>
                    <li><Link className="dropdown-item" to="/calculator?type=fd">Fixed Deposit Calculator</Link></li>
                    <li><Link className="dropdown-item" to="/calculator?type=hra">HRA Calculator</Link></li>
                    <li><Link className="dropdown-item" to="/calculator?type=nps">NPS Calculator</Link></li>
                    <li><Link className="dropdown-item" to="/calculator?type=personal-emi">Personal Loan EMI Calculator</Link></li>
                    </ul>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" id="nav_font" to="/goals" >Goal Tracking</Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" id="nav_font" to="/blogs" >Blog</Link>
                </li>

                <li className="nav-item d-flex align-items-center">
                    <button 
  className="btn btn-light rounded-10 btn-login" 
  onClick={handleLogin}
>
  Login
</button>
                </li>
                </ul>
            </div>
            </div>
        </nav>
    );
};

export default NavMenuHeader;